<script>
import GrazingsCard from '@/grazing/components/GrazingsCard.vue';
import FarmMap from '@/grazing/components/FarmMap.vue';
import GrazingAddForm from '@/grazing/components/GrazingAddForm.vue';

export default {
  components: {
    GrazingsCard,
    FarmMap,
    GrazingAddForm,
  },

  props: {
    farm: { type: Object, required: true },
  },

  data: () => ({
    selectedGrazingId: undefined,
    showAddGrazing: false,
  }),

  methods: {
    onGrazingSelected(grazing) { this.selectedGrazingId = grazing ? grazing.id : undefined; },
  },
}
</script>

<template>
  <div>

    <div class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <b-card>
          <h4 class="text-center mb-0">
            {{farm.name}}
          </h4>

          <div class="text-center mb-3">
            <b-badge variant="secondary"> {{farm.units.area}} </b-badge>
            <b-badge variant="secondary"> {{farm.units.weight}} </b-badge>
          </div>
        </b-card>
      </div>
    </div>

    <api-loader
      method="get"
      :url="`v1/farms/${farm.id}/grazings`"
      v-slot="{result: grazings}">
      <div class="row mt-4">

        <div class="col-sm-12 col-lg-5 mb-2">

          <grazings-card
            :farm="farm"
            :grazings="grazings"
            @grazing-selected="onGrazingSelected($event)" />

          <b-card class="mt-2">
            <button v-if="!showAddGrazing"
              type="button"
              class="btn btn-outline-primary btn-block"
              @click="showAddGrazing=true">
              Add Grazing
            </button>

            <grazing-add-form
              v-if="showAddGrazing"
              :farm-id="farm.id" />
          </b-card>

        </div>

        <div class="col-sm-12 col-lg-7">
          <b-card>
            <farm-map
              :farm="farm"
              :grazings="grazings"
              :selected-grazing-id="selectedGrazingId" />
          </b-card>
        </div>

      </div>
    </api-loader>

  </div>
</template>



// WEBPACK FOOTER //
// src/grazing/components/Farm.vue